import { useAuth0 } from "@auth0/auth0-react";
import { PromptDTO } from "../model/prompt";

export function usePromptAPI() {
  const { getAccessTokenSilently } = useAuth0();

  const getAllPrompts = (): Promise<PromptDTO[]> => {
    return new Promise((resolve, reject) => {
      getAccessTokenSilently().then((accessToken) => {
        fetch(`${process.env.REACT_APP_API_URL}/prompts/admin`, {
          headers: {
            authorization: `Bearer ${accessToken}`,
          },
        })
          .then((response) => {
            if (response.status === 200) {
              response.json().then((data: PromptDTO[]) => resolve(data)).catch(reject);
            } else {
              reject(new Error("Failed to fetch prompts: " + response.statusText));
            }
          })
          .catch(reject);
      }).catch(reject);
    });
  };
  const getPromptById = (id: string): Promise<PromptDTO> => {
    return new Promise((resolve, reject) => {
      getAccessTokenSilently().then((accessToken) => {
        fetch(`${process.env.REACT_APP_API_URL}/prompts/admin/${id}`, {
          headers: {
            authorization: `Bearer ${accessToken}`,
          },
        })
            .then((response) => {
              if (response.status === 200) {
                response.json().then((data: PromptDTO) => resolve(data)).catch(reject);
              } else {
                reject(new Error("Failed to fetch prompt: " + response.statusText));
              }
            })
            .catch(reject);
      }).catch(reject);
    });
  };

  const getAllActivePrompts = (): Promise<PromptDTO[]> => {
    return new Promise((resolve, reject) => {
      getAccessTokenSilently().then((accessToken) => {
        fetch(`${process.env.REACT_APP_API_URL}/prompts/admin/active`, {
          headers: {
            authorization: `Bearer ${accessToken}`,
          },
        })
          .then((response) => {
            if (response.status === 200) {
              response.json().then((data: PromptDTO[]) => resolve(data)).catch(reject);
            } else {
              reject(new Error("Failed to fetch prompts: " + response.statusText));
            }
          })
          .catch(reject);
      }).catch(reject);
    });
  };

  const createPrompt = (prompt: PromptDTO): Promise<PromptDTO> => {
    return new Promise((resolve, reject) => {
      getAccessTokenSilently().then((accessToken) => {

        fetch(`${process.env.REACT_APP_API_URL}/prompts/admin`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            authorization: `Bearer ${accessToken}`,
          },
          body: JSON.stringify(prompt)
        }).then((response) => {
          if (response.status === 200) {
            response.json().then((data: PromptDTO) => resolve(data)).catch(reject);
          } else {
            reject(new Error("Failed to update talent application status: " + response.statusText));
          }
        })
          .catch(reject);
      }).catch(reject);
    });
  };


  const updatePrompt = (id: string, prompt: PromptDTO): Promise<PromptDTO> => {
    return new Promise((resolve, reject) => {
      getAccessTokenSilently().then((accessToken) => {

        fetch(`${process.env.REACT_APP_API_URL}/prompts/admin/${id}`, {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            authorization: `Bearer ${accessToken}`,
          },
          body: JSON.stringify(prompt)
        }).then((response) => {
          if (response.status === 200) {
            response.json().then((data: PromptDTO) => resolve(data)).catch(reject);
          } else {
            reject(new Error("Failed to update prompt: " + response.statusText));
          }
        })
          .catch(reject);
      }).catch(reject);
    });
  };
  const deletePrompt = (id: string): Promise<PromptDTO> => {
    return new Promise((resolve, reject) => {
      getAccessTokenSilently().then((accessToken) => {

        fetch(`${process.env.REACT_APP_API_URL}/prompts/admin/${id}`, {
          method: "DELETE",
          headers: {
            "Content-Type": "application/json",
            authorization: `Bearer ${accessToken}`,
          }
        }).then((response) => {
          if (response.status === 200) {
            response.json().then((data: PromptDTO) => resolve(data)).catch(reject);
          } else {
            reject(new Error("Failed to delete prompt: " + response.statusText));
          }
        })
            .catch(reject);
      }).catch(reject);
    });
  };


  return { getAllPrompts, getPromptById, getAllActivePrompts, createPrompt, updatePrompt, deletePrompt };
}
